import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import { userPreferencesPort } from '@/infra/config/beans'
import { useQuery } from '@tanstack/react-query'
import { t } from 'i18next'
import FamilyCardListSkeleton from '@/src/components/global/family-card-list-skeleton/FamilyCardListSkeleton'
import FamilyCard from '@/src/components/global/family-card/FamilyCard'
import { getDiagnoses } from '@/infra/api/generated/diagnoses/diagnoses'

const { getDiagnosisHistories } = getDiagnoses()

const Index = () => {
  const { store, team } = useUserPreferences(userPreferencesPort)
  const { data: diagnoses, isFetching } = useQuery({
    queryKey: ['diagnoses', 'history', store?.id, team?.id],
    enabled: Boolean(store) && Boolean(team),
    queryFn: () => getDiagnosisHistories(store!.id, team!.id),
  })

  if (diagnoses?.length === 0) {
    return (
      <div className="w-full flex flex-col justify-center items-center text-center gap-2">
        <span className="font-semibold">{t('pages.home.no-history.title')}</span>
        <span className="text-content-quiet">{t('pages.home.no-history.subtitle')}</span>
      </div>
    )
  }

  return (
    <div className="w-full flex flex-col gap-3">
      {isFetching && <FamilyCardListSkeleton skeletonCount={2} />}
      {!isFetching &&
        diagnoses?.map((diag) => (
          <FamilyCard
            data-testid={`history-diagnosis-card-${diag.diagnosisId}`}
            key={diag.diagnosisId}
            family={diag.family}
            score={diag.score}
            date={diag.completedAt}
          />
        ))}
    </div>
  )
}

export default Index
